// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

let setHeaderScrollStatusBar = () => {
  const scrollElement = document.querySelector('html');
  const scrollTop = scrollElement.scrollTop;
  const scrollHeight = scrollElement.scrollHeight - scrollElement.clientHeight;
  const width = parseFloat(scrollTop) * 100 / parseFloat(scrollHeight);
  if (document.querySelector('[js-header-scroll-status-bar]'))
    document.querySelector('[js-header-scroll-status-bar]').style.width = width + '%';
}

document.addEventListener('DOMContentLoaded', () => {
  setHeaderScrollStatusBar();
  const colorVariantSelect = document.querySelector('.variant-picker--container:has(select[name="options[Color]"]) button.selected');
  if (colorVariantSelect) {
    setProductMediaSlider(colorVariantSelect.getAttribute('data-label'));
    setTimeout(() => {
      setFeaturedProductImage(colorVariantSelect.getAttribute('data-label'));
    }, 1000);
  }
});

document.addEventListener('scroll', (e) => {
  setHeaderScrollStatusBar();
});

let setFeaturedProductImage = (optionName, imageId=null, productId=null) => {
  document.querySelectorAll('.product__media-container .product__media').forEach((element) => {
    element.classList.remove('active');
    element.querySelectorAll('.product__media-item').forEach((item) => {
      item.classList.add('hidden');
    });
    if (element.getAttribute('data-option-value') == optionName) {
      element.classList.add('active');
      element.querySelectorAll('.product__media-item').forEach((item, index) => {
        if (index == 0) {
          item.classList.remove('hidden');
        }
      });
    }
  });
  document.querySelectorAll('.product__media-slider__container').forEach((element) => {
    element.classList.remove('active');
    element.classList.remove('initial');
    if (element.getAttribute('data-option-value') == optionName) {
      element.classList.add('active');
    }
    element.querySelectorAll('.product__media-slide').forEach((item) => {
      element.querySelector('[data-prev]').click();
    });
  });

  if (imageId != null && productId != null) {
    document.querySelectorAll('.custom-product-card[product-id="'+productId+'"]').forEach((element) => {
      element.querySelectorAll('[data-product-image-id]').forEach((image) => {
        if (image.getAttribute('data-product-image-id') == imageId) image.classList.remove('d-none');
        else image.classList.add('d-none');
      });
    });
  }
}

let setProductMediaSlider = (optionName=null) => {
  let mediaContainer;
  if (optionName == null) {
    mediaContainer == document.querySelector('.product__media-container .product__media.active');
  } else {
    mediaContainer = document.querySelector('.product__media-container .product__media[data-option-value="'+optionName+'"]');
  }
  if (mediaContainer == undefined) return;
  let index = 1;
  let totalIndex = 1;
  mediaContainer.querySelectorAll('.product__media-item').forEach((item) => {
    totalIndex = item.getAttribute('data-id');
  });
  // let originIndex;
  let percent;
  document.querySelectorAll('[js-product-carouse-scroll-status-bar]').forEach((element) => {
    // if (element.classList.contains('large-hide'))
    //   originIndex = element.getAttribute('js-data-index');
    element.setAttribute('js-data-index', index);
    element.setAttribute('js-data-total', totalIndex);
    percent = 100 * index / parseFloat(totalIndex);
    element.style.width = percent + '%';
    document.querySelectorAll('.product__media-container .desktop-carousel--buttons [js-data-left]').forEach((leftBtn) => {
      leftBtn.classList.add('disabled');
    });
    document.querySelectorAll('.product__media-container .desktop-carousel--buttons [js-data-right]').forEach((rightBtn) => {
      if (percent == 100)
        rightBtn.classList.add('disabled');
      else
        rightBtn.classList.remove('disabled');
    });
  });
  // for (let i = 0; i < index - originIndex; i++) {
  //   document.querySelectorAll('[data-slider]>[data-next]').forEach((element) => {
  //     element.click();
  //   });
  // }
  // for (let i = 0; i > index - originIndex; i--) {
  //   document.querySelectorAll('[data-slider]>[data-prev]').forEach((element) => {
  //     element.click();
  //   });
  // }
  document.querySelectorAll('[data-slider]>[data-prev]').forEach((element) => {
    if (percent == 0)
      element.setAttribute('disabled', '');
    else
      element.removeAttribute('disabled');
  });
  document.querySelectorAll('[data-slider]>[data-next]').forEach((element) => {
    if (percent == 100)
      element.setAttribute('disabled', '');
    else
      element.removeAttribute('disabled');
  });
}

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  const optionName = evt.detail.variant.featured_media.alt;
  const imageId = evt.detail.variant.featured_media.id;
  const productId = evt.detail.variant.featured_image.product_id;
  if (optionName) {
    setProductMediaSlider(optionName);
    setFeaturedProductImage(optionName, imageId, productId);
  }
});

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
// document.addEventListener("cart:item-added", function (evt) {
//   console.log("Item added to the cart");
//   console.log(evt.detail.product);
// });

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
// document.addEventListener("cart:updated", function (evt) {
//   console.log("Cart updated");
//   console.log(evt.detail.cart);
// });

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
// document.addEventListener("cart:error", function (evt) {
//   console.log("Cart error");
//   console.log(evt.detail.errorMessage);
// });

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
// document.addEventListener("quick-cart:open", function (evt) {
//   console.log("Quick cart opened");
//   console.log(evt.detail.cart);
// });

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// document.addEventListener("quick-cart:close", function () {
//   console.log("Quick cart closed");
// });

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
// document.addEventListener("product:quantity-update", function (evt) {
//   console.log("Product quantity updated");
//   console.log(evt.detail.quantity, evt.detail.variant);
// });

// This event fires whenever quickview modal is opened.
// This event is exposed when a 'Enable hover add-to-cart' feature is enabled
// And a quick view modal is opened.
// document.addEventListener("quickview:loaded", function () {
//   console.log("Quickview loaded");
// });

// This event fires whenever after additional collection items are
// added to the page due to filtering or click to load / infinite loading.
// document.addEventListener("products:loaded", function () {
//   console.log("Products loaded");
// });